module.exports = __webpack_public_path__ + "img/bridge.bcc27a0b.png";